/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2022-09-20 16:17:12
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-28 15:27:26
 * @FilePath: \umae-xiaou\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//引入UI框架
import Vant from 'vant'
//引入vant的css文件
import 'vant/lib/index.css'
//引入全局组件
import gCom from './common'
//引入全局过滤器
import gFilter from './filters'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import filters from "./filters/appFilters";
Object.keys(filters).forEach(key => {
 Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false
axios.defaults.withCredentials = true
Vue.prototype.$http = axios;

//调用UI框架
Vue.use(Vant)
Vue.use(ElementUI);

for (let i in gCom) {
  Vue.component(i, gCom[i])
}

for (let i in gFilter) {
  Vue.filter(i, gFilter[i])
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) { //拦截后设置标题
    document.title = to.meta.title
  }
  next()
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
